export default [
  {
    path: 'jogadores/jogadores',
    name: 'jogadores',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Jogadores',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Jogadores', link: 'jogadores.group' },
        { name: 'Jogadores', },
      ]
    }
  },
]